import React, { useEffect, useState } from 'react';
import { Minus, Square, X } from 'lucide-react';
import { t } from '../lib/i18n';
import { IS_WEB } from '../lib/platform';

/**
 * Pencere küçült / büyüt / kapat. Hem normal üst barda hem kayıt ekranının
 * kendi üst barında kullanılıyor — bu yüzden ayrı bileşen.
 */
export const WindowControls: React.FC<{ isDarkMode: boolean }> = (props) =>
  // Web'de pencereyi tarayıcı yönetiyor.
  IS_WEB ? null : <DesktopWindowControls {...props} />;

const DesktopWindowControls: React.FC<{ isDarkMode: boolean }> = ({ isDarkMode }) => {
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    window.zabit.isWindowMaximized().then(setIsMaximized);
    return window.zabit.onWindowMaximizedChange(setIsMaximized);
  }, []);

  return (
    <div className={`hidden md:flex items-center gap-1 ml-2 pl-2.5 border-l ${
      isDarkMode ? 'border-[#3A3A3E] text-neutral-500' : 'border-neutral-200 text-neutral-400'
    }`}>
      <button
        id="window-btn-minimize"
        onClick={() => window.zabit.minimizeWindow()}
        aria-label={t('Pencereyi simge durumuna küçült', 'Minimize window')}
        className={`p-1.5 rounded hover:bg-neutral-700/40 transition-colors ${
          isDarkMode ? 'hover:text-neutral-200' : 'hover:text-neutral-800'
        }`}
      >
        <Minus className="w-3.5 h-3.5" />
      </button>
      <button
        id="window-btn-maximize"
        onClick={() => window.zabit.toggleMaximizeWindow()}
        aria-label={isMaximized ? t('Pencereyi eski boyutuna getir', 'Restore window') : t('Pencereyi ekranı kapla', 'Maximize window')}
        className={`p-1.5 rounded hover:bg-neutral-700/40 transition-colors ${
          isDarkMode ? 'hover:text-neutral-200' : 'hover:text-neutral-800'
        }`}
      >
        <Square className="w-2.5 h-2.5" />
      </button>
      <button
        id="window-btn-close"
        onClick={() => window.zabit.closeWindow()}
        aria-label={t('Pencereyi kapat', 'Close window')}
        className="p-1.5 rounded hover:bg-rose-600 hover:text-[#F0EEE6] transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
